export const CALLBACK_REQUEST =
  "https://www.ewbanker.com/callbackrequest/bonds";

export const EASTWEST_ONLINE_PAGE =
  "https://personal.eastwestbanker.com/Retail/servletcontroller";
export const EASYWAY_PERSONAL_ONLINE = "https://ewonline.eastwestbanker.com/";
export const EASYBIZ_CORPORATE_ONLINE = "https://business.eastwestbanker.com/";
export const EASTWEST_PERSONAL_ONLINE = "https://personal.eastwestbanker.com/";
export const EASTWEST_CORPORATE =
  "https://www.eastwestcorporate.com.ph/fo/login";
export const EASTWEST_MESSENGER = "https://m.me/EastWestBanker";
export const EASTWEST_AUCTION_MESSENGER = "http://www.ewlend.com/auction";
export const TRAVEL_MONEY_URL =
  "https://travelmoney.eastwestbanker.com/ewbprepaid/html/LoginFrame.html";

export const OLD_EASYWAY = "https://www.ewbanker.com/easyway.asp?mode=d";
export const PRIORITY_WEBSITE = "https://priority.eastwestbanker.com/";
export const AGEAS_INSURANCE = "https://ewageas.com.ph/";
export const INSURANCE_BROKERAGE =
  "https://www.ewbanker.com/EastWestInsuranceBrokerage";
